import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["open"]

  toggle() {
    this.element.classList.toggle(this.openClass)
  }
}
